/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type GLAccountType = "ASSET" | "COGS" | "EQUITY" | "EXPENSE" | "LIABILITY" | "REVENUE";
export type GLNormalBalance = "CREDIT" | "DEBIT";
import type { FragmentReference } from "relay-runtime";
declare export opaque type ChartOfAccountsTable_glAccountEdges$ref: FragmentReference;
declare export opaque type ChartOfAccountsTable_glAccountEdges$fragmentType: ChartOfAccountsTable_glAccountEdges$ref;
export type ChartOfAccountsTable_glAccountEdges = $ReadOnlyArray<{|
  +node: {|
    +id: string,
    +accountNumber: string,
    +name: string,
    +description: ?string,
    +accountType: GLAccountType,
    +normalBalance: GLNormalBalance,
    +balance: number,
    +isActive: boolean,
    +isSystem: boolean,
    +parentAccount: ?{|
      +id: string,
      +name: string,
    |},
  |},
  +$refType: ChartOfAccountsTable_glAccountEdges$ref,
|}>;
export type ChartOfAccountsTable_glAccountEdges$data = ChartOfAccountsTable_glAccountEdges;
export type ChartOfAccountsTable_glAccountEdges$key = {
  +$data?: ChartOfAccountsTable_glAccountEdges$data,
  +$fragmentRefs: ChartOfAccountsTable_glAccountEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ChartOfAccountsTable_glAccountEdges",
  "type": "GLAccountEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "GLAccount",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accountNumber",
          "args": null,
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "accountType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "normalBalance",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "balance",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isActive",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isSystem",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "parentAccount",
          "storageKey": null,
          "args": null,
          "concreteType": "GLAccount",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e07c94af90c299eeaf5540dc0f8a052a';
module.exports = node;
